// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { N40 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FormCardsContainer = styled.div({
  position: 'relative'
});

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FormCards = styled.div`
	border: 1px solid ${`var(--ds-border, ${N40})`};
	border-radius: ${"var(--ds-space-050, 4px)"};
	${({
  isIndexLoading
}) => isIndexLoading ? `opacity: ${"var(--ds-opacity-loading, 0.2)"}` : ''};
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SpinnerBackdrop = styled.div({
  display: 'flex',
  position: 'absolute',
  inset: '15px 0',
  alignItems: 'center',
  justifyContent: 'center'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const EmptyFormsLoadingPlaceholder = styled.div({
  height: '60px'
});